module.exports = __webpack_public_path__ + "d8bf1ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/index_hero/gogobusiness/gogovan_logo.png
// module id = 1668
// module chunks = 0